import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { BusStudentsService } from '../_services/bus-students.service';
import { Filter } from 'src/app/user-management/_model/filter.model';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { ControlDeletionService } from 'src/app/_services/control-deletion.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ParentService } from 'src/app/user-management/_services/parent.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { RoutesService } from '../_services/routes.service';
import { MessagesControlService } from 'src/app/_services/messages-control.service';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { ModalService } from 'src/app/shared/modal/modal.service';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';

declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-bus-students',
  templateUrl: './bus-students.component.html',
  styleUrls: ['./bus-students.component.scss']
})
export class BusStudentsComponent implements OnInit {
  @ViewChild('busModalContainer', { read: ViewContainerRef }) modalContainer!: ViewContainerRef;
  loading = true;
  tableControls: any = { data: [] };
  pageSize = 25;
  pageNumber = 1;
  searchText = "";
  dataArray: any = [];
  sortBy = "route_name";
  sortOrder = "asc";
  grades = [];
  rowsView = "list";
  filterValues: Filter;

  selectedCheckBoxes = [];
  listType: string;


  rowsSubscription;
  searchSubscription;
  filterSubscription;

  selectedStudent;
  routesPageSize = 25;
  routesPageNumber = 1;
  routesSearchText = "";
  routesSortBy = "route_name";
  routesSortOrder = "asc";
  routesRowsView = "list";
  routesFilterValues: Filter;
  routesDataArray: any = [];
  routesTableControls: any = { data: [] };
  routesSelectedCheckBoxes = [];
  routesListType = "available-routes-list";
  filterStatus = false;
  from;
  to;
  total;
  currLang;
  openedModalFlag = false;
  openedEnrollFlag = false;
  callBusApi = true;
  filterApplied;
  destroy$ = new Subject<void>(); 
  schoolNotSubscribedToCommute: boolean = false;

  constructor(private busesStudentsService: BusStudentsService,
    private routesService: RoutesService,
    private parentService: ParentService,
    private dataService: DataService,
    private translate: TranslateService,
    private controlDeletion: ControlDeletionService,
    private controlMessaging: MessagesControlService,
    private globalService: GlobalService,
    private modalService: ModalService,
    private errorMsgService: ErrorMsgService) {
      this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng =>{
        this.currLang = lng;
        this.translate.use(this.currLang);
      });
     }

  ngOnInit(): void {
    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    this.dataService.getEnrollStatus().pipe(takeUntil(this.destroy$)).subscribe(res=>{
      this.openedEnrollFlag = res;
    })
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng =>{
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    $(document).on('hidden.bs.modal', '#assignToRoute', () => {
      this.closeAssignPopup();
    })

    this.loading = true;
    this.listType = "bus-" + window.location.pathname.split('/')[2];
    this.dataService.setFilterValue(new Filter());
    this.dataService.getFilterStatus().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.filterStatus = res;
    })

    this.controlDeletion.toggleDeleteBtn(false);
    this.controlMessaging.toggleMessageBtn(false);
    this.controlBarSubscriptions();
    this.getBusesStudentsData();
    // this.getAvailableRoutesData();
    this.dataService.getAllGrades().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.grades = res;
      this.dataService.sentGrades(this.grades)
    })
  }

  ngOnDestroy(): void {
    this.rowsSubscription.unsubscribe();
    this.searchSubscription.unsubscribe();
    this.filterSubscription.unsubscribe();
    this.dataService.toggleFilterStatus(false);
  }

    controlBarSubscriptions() {
    this.rowsSubscription = new Subscription();
    this.searchSubscription = new Subscription();
    this.filterSubscription = new Subscription();
    this.dataService.getRowsStyle().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.rowsView = res ? "compact" : "list";
      this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
        this.setTableData();
      });
      this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(res => {
        this.setTableData();
      });
    });
    let rowsNumbers = this.dataService.getRowsNumberShown().subscribe(res => {
      this.selectedCheckBoxes = [];
      this.pageSize = res;
      this.pageNumber = 1;
      // this.AllRowsIsChecked = false;
      this.dataService.setSearchText(null);
      // this.searchText = '';
      this.selectChanged({
        index: "all",
        data: "all",
        checked: false
      });
      this.globalService.stopLoading();
      this.getBusesStudentsData();
    });
    this.rowsSubscription.add(rowsNumbers);

    let textSearch = this.dataService.getSearchText().subscribe(res => {
      this.globalService.startLoading();
      this.loading = true;
      if (res !== null && !this.openedEnrollFlag) {
        this.searchText = res;
        this.selectChanged({
          index: "all",
          data: "all",
          checked: false
        });
        this.getBusesStudentsData();
      }
    });
    this.searchSubscription.add(textSearch);

    let filter = this.dataService.getFilterValue().subscribe((res: any) => {
      this.globalService.startLoading();
      this.loading = true;
      this.filterValues = res;
      if(this.filterValues.grades || this.filterValues.classes ){
        if(this.filterValues.grades.length>0 || this.filterValues.classes.length>0){
          this.filterApplied = true;
        }
        else{
          this.filterApplied = false;
        }

      }
      else{
        this.filterApplied = false;
      }
      
      this.getBusesStudentsData();
    });
    this.filterSubscription.add(filter);
    this.filterValues.grades = [];
    if (this.routesFilterValues !== undefined) {
      this.routesFilterValues.grades = [];
    }
  }

  // controlBarSubscriptions() {
  //   this.rowsSubscription = new Subscription();
  //   this.searchSubscription = new Subscription();
  //   this.filterSubscription = new Subscription();
  //   this.dataService.getRowsStyle().subscribe((res: any) => {
  //     if (this.openedModalFlag) {
  //       this.routesRowsView = res ? "compact" : "list";
        
  //       // this.translate.get('init').subscribe(res => {
  //       //   this.setAvailableRoutesTableData();
  //       // });
  //       // this.translate.onLangChange.subscribe(res => {
  //       //   this.setAvailableRoutesTableData();
  //       // });
  //     } else {
  //       this.rowsView = res ? "compact" : "list";
  //       this.translate.get('init').subscribe(res => {
  //         this.setTableData();
  //       });
  //       this.translate.onLangChange.subscribe(res => {
  //         this.setTableData();
  //       });
  //     }
  //   });
  //   let rowsNumbers = this.dataService.getRowsNumberShown().subscribe(res => {
  //     this.selectedCheckBoxes = [];
  //     this.pageSize = res;
  //     this.pageNumber = 1;
  //     // this.AllRowsIsChecked = false;
  //     this.dataService.setSearchText(null);
  //     this.globalService.stopLoading();

  //     this.getBusesStudentsData();

  //     if (this.openedModalFlag) {
  //       this.routesSelectedCheckBoxes = [];
  //       this.routesPageSize = res;
  //       this.routesPageNumber = 1;
  //       // this.AllRowsIsChecked = false;
  //       this.dataService.setSearchText(null);
  //       // this.routesSelectChanged({
  //       //   index: "all",
  //       //   data: "all",
  //       //   checked: false
  //       // });

  //       // this.getAvailableRoutesData();
  //     } else {
  //       this.selectedCheckBoxes = [];
  //       this.pageSize = res;
  //       this.pageNumber = 1;
  //       // this.AllRowsIsChecked = false;
  //       this.dataService.setSearchText(null);
  //       this.selectChanged({
  //         index: "all",
  //         data: "all",
  //         checked: false
  //       });
  //       this.getBusesStudentsData();
  //     }
  //   });
  //   this.rowsSubscription.add(rowsNumbers);

  //   let textSearch = this.dataService.getSearchText().subscribe(res => {
  //     this.globalService.startLoading();
  //     this.loading = true;
  //     if (res !== null) {
  //       if (this.openedModalFlag) {
  //         this.routesSearchText = res;
  //         // this.routesSelectChanged({
  //         //   index: "all",
  //         //   data: "all",
  //         //   checked: false
  //         // });
  //         // this.getAvailableRoutesData();
  //       } else {
  //         this.loading = true;
  //         this.searchText = res;
  //         this.selectChanged({
  //           index: "all",
  //           data: "all",
  //           checked: false
  //         });
  //         this.getBusesStudentsData();
  //       }
  //     }
  //   });
  //   this.searchSubscription.add(textSearch);

  //   let filter = this.dataService.getFilterValue().subscribe((res: any) => {
  //     this.globalService.startLoading();
  //     this.loading = true;
  //     this.filterValues = res;
  //     this.getBusesStudentsData();
  //     if (this.openedModalFlag) {
  //       this.routesFilterValues = res;
  //       // this.getAvailableRoutesData();
  //     } else {
  //       this.filterValues = res;
  //       this.getBusesStudentsData();
  //     }
  //   });
  //   this.filterSubscription.add(filter);
  //   this.filterValues.grades = [];
  //   if (this.routesFilterValues !== undefined) {
  //     this.routesFilterValues.grades = [];
  //   }
  // }

  getBusesStudentsData() {
   
    if(this.callBusApi){ 
      this.callBusApi =false;
      this.globalService.startLoading();
      this.loading = true;
      this.busesStudentsService.getAllStudentsInBusSystem(1, this.pageSize, this.sortBy, this.sortOrder, this.searchText, this.pageNumber, this.filterValues).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.schoolNotSubscribedToCommute = false;
        let dataArray = [];
        res['data'].forEach(element => {
          dataArray.push({
            student_image: element?.image_path,
            name: element?.name,
            grade_name: element.class?.grade?.name,
            parent_data: element?.users[0],
            // route_name: element.route === null ? this.translate.instant('buses.table-controls.assign-to-route') : element.route.route_name,
            // route_name_link: element.route === null ? true : false,
            parent_address: element?.users[0]?.address === null || element?.users[0]?.address === undefined ? this.translate.instant('buses.table-controls.add-parent-address') : element?.users[0]?.address,
            parent_address_link: element?.users[0]?.address === null || element?.users[0]?.address === undefined ? true : false,
            id: element?.id,
            gender: element?.gender
          })
        });
        this.dataArray = dataArray;
        this.from = res["from"];
        this.to = res["to"];
        this.total = res["total"];
        this.selectedCheckBoxes = [];
        this.controlDeletion.toggleDeleteBtn(false);
        this.controlMessaging.toggleMessageBtn(false);
        this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
          this.setTableData();
        });
        this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(res => {
          this.setTableData();
        });
        this.loading = false;
        this.globalService.stopLoading();
      },err=>{
        this.errorHandler(err)
      },
      ()=>{
        this.callBusApi = true;
      })
    }
  
  }

  setTableData() {
    this.tableControls = {
      selection: true,
      paging: true,
      view: this.rowsView,
      title:'table-view.titles.bus-subscribers',
      selectedTitle:'table-view.selected-titles.bus-subscribers',
      totalTitle:'table-view.total-titles.bus-subscribers',
      pagination: {
        from: this.from,
        to: this.to,
        total: this.total
      },
      columns: [
        {
          name: "",
          sort: false,
          type: "image",
          source: "student_image"
        },
        {
          name: this.translate.instant('buses.table-controls.student-name'),
          sort: true,
          type: "string",
          source: "name"
        },
        {
          name: this.translate.instant('buses.table-controls.grade'),
          sort: true,
          type: "string",
          source: "grade_name"
        },
        {
          name: this.translate.instant('buses.table-controls.gender'),
          sort: false,
          type: "gender",
          source: "gender"
        },
        // {
        //   name: this.translate.instant('buses.table-controls.route-name'),
        //   sort: false,
        //   type: "string",
        //   source: "route_name"
        // },
        {
          name: this.translate.instant('buses.table-controls.parent-address'),
          sort: false,
          type: "string",
          source: "parent_address"
        },
      ],
      data: this.dataArray
    }
  }

  tableEventHandeler(event) {
    switch (event.action) {
      case "rowClicked":
        this.rowClicked(event.target);
        break;
      case "checkboxChanged":
        this.selectChanged(event.target);
        break;
      case "sorting":
        this.sorting(event.target);
        break;
      case "linkClicked":
        this.linkClicked(event.target);
        break;
      case "pagination":
        this.paginationHandling(event.target);
        break;
    }
  }

  rowClicked(event) {
    event.index;
    event.data;
  }

  selectChanged(event) {
    let index = event.index;
    let row = event.data;
    let checked = event.checked;
    let allRows = event.dataValues;
    if (checked) { // checked
      if (index == "all") {
        this.selectedCheckBoxes = allRows;
      } else {
        this.selectedCheckBoxes.push(row);
      }
    } else { // unchecked
      if (index == "all") {
        this.selectedCheckBoxes = [];
      } else {
        this.selectedCheckBoxes = this.selectedCheckBoxes.filter(selected=> selected.id != row.id);
      }
    }

    if (this.selectedCheckBoxes.length > 0) {
      this.controlDeletion.toggleDeleteBtn(true);
      this.controlMessaging.toggleMessageBtn(true);
    } else {
      this.controlDeletion.toggleDeleteBtn(false);
      this.controlMessaging.toggleMessageBtn(false);
    }
  }

  linkClicked(event) {
    this.selectedStudent = event.row;
    if (event.source == "route_name") {
      this.openAssignPopup();
    } else if (event.source == "parent_address") {
      if(event.row.parent_data){
        this.openModal('add-parent' , 'edit' , event.row.parent_data)
      } else {
        let errorMsg = this.translate.instant('buses.bus-students.parent-not-found');
        this.errorMsgService.setMessage(errorMsg);
      }
      // this.openParentModal(event.row.parent_data);
    }
  }

  paginationHandling(event) {
    this.pageNumber += event.dir;
    this.getBusesStudentsData();
  }

  openParentModal(parent) {
    this.parentService.setParentData(parent, 'edit');
    $("#addParentModal").modal("show");
  }

  openAssignPopup() {
    // this.controlDeletion.toggleDeleteBtn(false);
    // this.controlMessaging.toggleMessageBtn(false);
    this.openedModalFlag = true;
    $("#assignToRoute").modal("show");
    // this.getAvailableRoutesData();
  }

  closeAssignPopup() {
    // this.controlDeletion.toggleDeleteBtn(false);
    // this.controlMessaging.toggleMessageBtn(false);
    this.openedModalFlag = false;
  }

  sorting(event) {
    this.sortOrder = event.order;
    this.sortBy = event.source;

    this.selectChanged({
      index: "all",
      data: "all",
      checked: false
    });

    this.getBusesStudentsData();
  }

  addStudentToBus() {
    this.dataService.toggleEnrollStatus(true);
    setTimeout(() => {
      $("#enrollStudents").modal("show");
      this.dataService.setFilterValue(new Filter());
      this.dataService.setFilterFlag('close');
    }, 500);
  }


  // getAvailableRoutesData() {
  //   this.routesService.getAllRoutes(this.routesPageSize, this.routesSortBy, this.routesSortOrder, this.routesSearchText, this.routesPageNumber, this.routesFilterValues, 0).subscribe(res => {
  //     let data: any = res;
  //     let dataArray = [];
  //     data.forEach(element => {
  //       if (element.students_count < element.capacity) {
  //         dataArray.push(
  //           {
  //             color: element.color,
  //             route_name: element.route_name,
  //             bus_name: element.bus_name,
  //             driver_name: element.driver?.name,
  //             supervisor_name: element.supervisor?.name,
  //             capacity: element.students_count + "/" + element.capacity,
  //             id: element.id
  //           }
  //         );
  //       }
  //     });
  //     this.routesDataArray = dataArray;
  //     this.translate.get('init').subscribe(res => {
  //       this.setAvailableRoutesTableData();
  //     });
  //     this.translate.onLangChange.subscribe(res => {
  //       this.setAvailableRoutesTableData();
  //     });
     
  //     if(this.openedModalFlag){
  //       this.loading = false;
  //     }
  //     // this.globalService.stopLoading();
  //   });
  // }
  // setAvailableRoutesTableData() {
  //   this.routesTableControls = {
  //     selection: true,
  //     singleSelect: true,
  //     paging: true,
  //     view: this.routesRowsView,
  //     columns: [
  //       {
  //         name: this.translate.instant('buses.table-controls.route-color'),
  //         sort: false,
  //         type: "color",
  //         source: "color"
  //       },
  //       {
  //         name: this.translate.instant('buses.table-controls.route-name'),
  //         sort: true,
  //         type: "string",
  //         source: "route_name"
  //       }, {
  //         name: this.translate.instant('buses.table-controls.bus-name'),
  //         sort: true,
  //         type: "string",
  //         source: "bus_name"
  //       }, {
  //         name: this.translate.instant('buses.table-controls.driver-name'),
  //         sort: false,
  //         type: "string",
  //         source: "driver_name"
  //       }, {
  //         name: this.translate.instant('buses.table-controls.suprevisor-name'),
  //         sort: false,
  //         type: "string",
  //         source: "supervisor_name"
  //       }, {
  //         name: this.translate.instant('buses.table-controls.bus-capacity'),
  //         sort: false,
  //         type: "string",
  //         source: "capacity"
  //       }
  //     ],
  //     data: this.routesDataArray
  //   }
  // }

  // routesTableEventHandeler(event) {
  //   switch (event.action) {
  //     case "checkboxChanged":
  //       this.routesSelectChanged(event.target);
  //       break;
  //     case "sorting":
  //       this.routesSorting(event.target);
  //       break;
  //   }
  // }

  // routesSelectChanged(event) {
  //   let index = event.index;
  //   let row = event.data;
  //   let checked = event.checked;

  //   if (checked) { // checked
  //     this.routesSelectedCheckBoxes = [row.id];
  //   } else { // unchecked
  //     this.routesSelectedCheckBoxes = [];
  //   }

  // }
  // routesSorting(event) {
  //   this.routesSortOrder = event.order;
  //   this.routesSortBy = event.source;

  //   this.getAvailableRoutesData();
  // }
  assignBtn() {
    let body = {
      student_ids: [this.selectedStudent.id],
      route_id: this.routesSelectedCheckBoxes[0],
      append: true
    }
    this.routesService.assignStudentsToRoute(body).subscribe((res: any) => {
      $("#assignToRoute").modal("hide");
      this.dataService.setCreateRouteData({
        routeId: this.routesSelectedCheckBoxes[0],
        studentId: this.selectedStudent.id
      });
      this.getBusesStudentsData();
      this.openMapPopup(body.route_id);
    })
  }
  openMapPopup(route_id) {
    this.routesService.getSingleRoute(route_id).subscribe((res: any) => {
      let routeData = res;
      routeData["submitMode"] = "order";
      this.dataService.setCreateRouteData(routeData);
    })
  }

  openModal(modalType:string , mode:string , data:any): void {
    const modalConfig = this.modalService.createModalConfig(modalType , mode , data  );
    this.modalService.openModal(modalConfig, this.modalContainer);
  }

    generateExcelFile() {
      this.busesStudentsService.exportAllStudentsInBusSystemReport(1, this.pageSize, this.sortBy, this.sortOrder, this.searchText, this.pageNumber, this.filterValues).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      })
    }

    errorHandler(error) {
      if (error?.status == 403) {
        this.loading = false;
        this.schoolNotSubscribedToCommute = true;
      }
    }
}
